import React from 'react'
import { Tooltip } from '@mobi/component-library/Overlays/Tooltip'
import { QuickShare } from '@core/Areas/BetLoop/Components/QuickShare'
import { FloatingActionButton } from './Components/FloatingActionButton'
import { useOutsideClick } from 'rooks'
import { useOnboardingTooltips } from '@core/Areas/BetLoop/hooks/useOnboardingTooltips'

export const QuickShareButton: React.FC<{ isOnProfile?: boolean; shouldHideButton?: boolean }> = ({
  isOnProfile,
  shouldHideButton,
}) => {
  const [isQuickShareOpen, setIsQuickShareOpen] = React.useState(false)

  const handleQuickShareClick = () => setIsQuickShareOpen(curr => !curr)
  const handleQuickShareDismiss = () => setIsQuickShareOpen(curr => !curr)

  const floatingActionRef = React.useRef<HTMLDivElement>(null)
  const { currentTooltipId, onDismissed } = useOnboardingTooltips('bet-loop-share-bet-button')
  const shouldShowTooltip = currentTooltipId === 'bet-loop-share-bet-button' && !shouldHideButton
  useOutsideClick(floatingActionRef, () => {
    if (shouldShowTooltip) onDismissed('bet-loop-share-bet-button')
  })

  React.useEffect(() => {
    if (!floatingActionRef.current) return

    floatingActionRef.current.style.transition = 'opacity 125ms ease'
    floatingActionRef.current.style.opacity = shouldHideButton ? '0' : '1'
    floatingActionRef.current.style.pointerEvents = shouldHideButton ? 'none' : 'unset'
  }, [shouldHideButton])

  return (
    <>
      <QuickShare isOpen={isQuickShareOpen} onDismiss={handleQuickShareDismiss} />

      <FloatingActionButton
        label={isOnProfile ? undefined : 'Share a Bet'}
        shouldUseSpacer={!isOnProfile}
        iconName='CustomAddBet'
        onClick={handleQuickShareClick}
        ref={floatingActionRef}
      />

      {shouldShowTooltip && (
        <Tooltip
          color='blue'
          triggerElRef={floatingActionRef}
          tooltipId='bet-loop-share-bet-button'
          hasTooltipBeenSeen={() => false}
          shouldHideCrossIcon
          shouldOnlyRenderSingleInstance={true}
          offsetYPx={7}
          offsetXPx={8}
          onDismissed={() => onDismissed('bet-loop-share-bet-button')}
          strategyPosition='fixed'
          preferredPlacement='top'
        >
          <div style={{ minWidth: '11.2rem' }}>Share your</div>
          <div>pending bets</div>
        </Tooltip>
      )}
    </>
  )
}
